import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import windowWidthReducer from '../features/windowWidth/windowWidth';
import searchKeywordReducer from '../features/searchKeyword/searchKeyword';
import idReducer from '../features/id/id';
import loginReducer from '../features/login/login';
import editIDReducer from '../features/editID/editID';
import professorEditIDReducer from '../features/professorEditID/professorEditID';
import googleLoginReducer from '../features/googleLogin/googleLogin'
import nameReducer from '../features/name/name';
import saveFormReducer from '../features/saveForm/saveForm';
import saveProfessorReducer from '../features/saveProfessorForm/saveProfessorForm';
import saveNewCourseReducer from '../features/saveNewCourse/saveNewCourse';
const saveFormPersistConfig = {
  key: 'saveForm',
  storage,
};
const saveProfessorFormPersistConfig = {
  key: 'saveProfessorForm',
  storage,
};
const saveNewCoursePersistConfig = {
  key: 'saveNewCourse',
  storage,
};
const saveFormPersistedReducer = persistReducer(
  saveFormPersistConfig,
  saveFormReducer
);
const saveProfessorFormPersistedReducer = persistReducer(
  saveProfessorFormPersistConfig,
  saveProfessorReducer
);
const saveNewCoursePersistedReducer = persistReducer(
  saveNewCoursePersistConfig,
  saveNewCourseReducer
);
const rootReducer = combineReducers({
  windowWidth: windowWidthReducer,
  searchKeyword: searchKeywordReducer,
  id: idReducer,
  login: loginReducer,
  googleLogin: googleLoginReducer,
  editID: editIDReducer,
  professorEditID: professorEditIDReducer,
  name: nameReducer,
  saveForm: saveFormPersistedReducer,
  saveProfessorForm : saveProfessorFormPersistedReducer,
  saveNewCourse: saveNewCoursePersistedReducer,
});
export const store = configureStore({
  reducer: rootReducer,
});
export const persistor = persistStore(store);